import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';
import SelectWrap from "../../../../components/SelectWrap";
import countries from "../../../../data/countries";

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.booster) {
            const { booster } = this.props;

            this.state = {
                id: booster.id,
                feed: booster.feed,
                subid: booster.subid,
                country: booster.country ? booster.country.split(',') : '',
                factor: booster.factor,
                update: true
            };
        }
        else this.state = { feed: '', subid: '', country: '', };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <SelectWrap
                        values={this.props.feeds}
                        label="Feed:"
                        name="feed"
                        onChange={this.handleFieldChange}
                        value={this.state.feed}
                        required
                    />
                    <FieldGroup
                        name="subid"
                        label="Subid:"
                        onChange={this.handleFieldChange}
                        value={this.state.subid}
                    />
                    <SelectWrap
                        values={countries}
                        label="Countries:"
                        name="country"
                        onChange={this.handleFieldChange}
                        value={this.state.country}
                        multi
                    />
                    <FieldGroup
                        type="number"
                        step={0.01}
                        name="factor"
                        label="Factor:"
                        onChange={this.handleFieldChange}
                        value={this.state.factor}
                        required
                    />
                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/AdkBoosters/components/Form/index.js